__turbopack_context__.v({
  "inner": "RuneScape-module__FNEHlW__inner",
  "wrapper": "RuneScape-module__FNEHlW__wrapper",
});
